import { FormInputMeta } from '@Modules/core/types/FormMetaType';
import { getValidationSchema } from '@Shared/utils/validationSchema';

import * as yup from "yup";


export interface IHSMFormMeta {
  identifier: FormInputMeta;
  name: FormInputMeta;
  status: FormInputMeta;
  lastUpTime: FormInputMeta;
  lastDownTime: FormInputMeta;
  processIdentifier: FormInputMeta;
  maxTraceSize: FormInputMeta;
  fchTrace: FormInputMeta;
  level: FormInputMeta;
  production: FormInputMeta;
  verification: FormInputMeta;
  startScript: FormInputMeta;
  stopScript: FormInputMeta;
  timeOut: FormInputMeta;
  pinWidth: FormInputMeta;
  refreshMethod: FormInputMeta;
  // Schema
  schema: any,
}

const HSMFormMeta = {} as IHSMFormMeta;

HSMFormMeta.identifier = {
  name: 'identifier',
  type: 'text',
  label: 'ID',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
HSMFormMeta.name = {
  name: 'name',
  type: 'text',
  label: 'Nom',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
HSMFormMeta.status = {
  name: 'status',
  type: 'text',
  label: 'Statut',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
HSMFormMeta.lastUpTime = {
  name: 'lastUpTime',
  type: 'datetime',
  label: 'Dernier Up Time',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
HSMFormMeta.lastDownTime = {
  name: 'lastDownTime',
  type: 'datetime',
  label: 'Dernier Down Time',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
HSMFormMeta.processIdentifier = {
  name: 'processIdentifier',
  type: 'text',
  label: 'Id Process',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
HSMFormMeta.maxTraceSize = {
  name: "maxTraceSize",
  label: "Taille Max Trace",
  type: "text",
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
HSMFormMeta.fchTrace = {
  name: 'fchTrace',
  type: 'number',
  label: 'Fichier Trace',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
HSMFormMeta.level = {
  name: 'level',
  type: 'select',
  label: 'Niveau',
  options: [],
  validation: yup.string().required("Ce champ est requis"),
};
HSMFormMeta.production = {
  name: 'production',
  type: 'checkbox',
  label: 'Production',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
HSMFormMeta.verification = {
  name: 'verification',
  type: 'checkbox',
  label: 'Verification',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
HSMFormMeta.startScript = {
  name: 'startScript',
  type: 'text',
  label: 'Script de demarrage',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
HSMFormMeta.stopScript = {
  name: 'stopScript',
  type: 'text',
  label: 'Script d\'arrêt',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
HSMFormMeta.timeOut = {
  name: 'timeOut',
  type: 'text',
  label: 'Time out',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
HSMFormMeta.pinWidth = {
  name: 'pinWidth',
  type: 'number',
  label: 'Longueur Pin',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
HSMFormMeta.refreshMethod = {
  name: "refreshMethod",
  label: "Methode de rafraichissement",
  type: "select",
  options:  [
    {
      label:'Taille',
      value: 't',
    },
    {
      label:'Quotidiennement',
      value: 'q',
    },
  ],
  validation: yup.string().required("Ce champ est requis"),
};




HSMFormMeta.schema = yup.object().shape(getValidationSchema(HSMFormMeta));

export default HSMFormMeta;